import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Sweet = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Десерти'/>
            <main className={s.main}>
                <Product name='Штрудель з яблуками' price='45 грн.' weight='100г.'/>
                <Product name='Штрудель з вишнею' price='45 грн.' weight='100г.'/>
                <Product name='Смажене морозиво' price='45 грн.' />
                <Product name='Смажене молоко' price='45 грн.' />

                <Product name='Млинці з маком' price='60 грн.' weight='190г.'/>
                <Product name='Млинці з сиром' price='60 грн.' weight='190г.'/>
                <Product name='Млинці тріо' price='65 грн.' weight='250г.'/>
                <Product name='Млинці з шоколадно – фундучною пастою' price='75 грн.' weight='190г.'/>
                <Product name='Млинці із згущеним молоком' price='50 грн.' weight='150г.'/>

                <Product name='Бананове морозиво з какао' price='70 грн.' weight='100г.' info1='банан, какао, мелений горіх'/>
                <Product name='Крем-пудінг з грушою та бананом' price='60 грн.' weight='220г.' info1="груша, банан, молоко, лимонний сік, шматочки шоколаду, м'ята"/>
                <Product name='Фруктовий десерт з маршмеллоу ' price='55 грн.' weight='300г.' info1="банан, ківі, малина, маршмеллоу"/>
                <Product name='Персиковий смузі-боул з малиною і чорницею' price='65 грн.' weight='300г.' info1="йогурт, персик, малина, чорниця, мак, кокосова стружка, м'ята"/>
                <Product name='Цитрусовий смузі-боул з бананом та шоколадними пластівцями' price='60 грн.' weight='300г.' info1="банан, апельсин, грейпфрут, мандарин, шоколадні пластівці, сік лимону, мед, мак"/>

                <Product name='Bubble вафля' price='25 грн.' info1="ванільна, шоколадна"/>
                <Product name='Ялинка' price='30 грн.' info1="(класична, шоколадна) з топінгом на вибір"/>
                <Product name='Оладки' price='30 грн.' info1="з топінгом на вибір"/>
                <Product name='Донатс' price='10 грн.' info1="з топінгом на вибір"/>
                <Product name='Горішки із згущеним молоком' price='12 грн.'/>
                <Product name='Вафельна трубочка із згущеним молоком  ' price='25 грн.'/>
            
                <Product name='Еклер з Рафаело' price='20 грн.' info1="з пряженим молоком, з абрикосовим джемом"/>
                <Product name='Печиво імбирне' price='20 грн.' info2="різнобарвна посипка + 5 грн." info3="різнобарвне драже + 5 грн." info4="Шоколадом + 5 грн."/>
                <Product name='Круасан' price='45 грн.' info1="з джемом, з шоколадно-фундучною пастою, із згущеним молоком"/>
                <Product name='Кекс' price='20 грн.' info1="з ізюмом, з шоколадом, класичний"/>
            </main>
        </div>
    )
}

export default Sweet;